<template>
  <v-flex xs12 sm12 md12>
    <v-autocomplete
      :loading="loading"
      :items="items"
      item-text="title"
      item-value="id"
      :search-input.sync="search"
      v-model="customer"
      cache-items
      class="mx-3"
      dense
      solo
      hide-no-data
      hide-details
      label="客户"
      >
    </v-autocomplete>
  </v-flex>
</template>

<style>
</style>

<script>
import { getCustomerList } from '@/api/customer'

export default {
  name: 'CustomerSel',
  data () {
    return {
      loading: false,
      items: [],
      search: null,
      customer: null
    }
  },
  watch: {
    search (val) {
      this.qrySelections(val)
    },
    customer (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    qrySelections (v) {
      this.loading = true
      let d = {
        'title': v,
        'page': 1,
        'perPage': 9999
      }
      getCustomerList(d).then(res => {
        this.loading = false
        this.items = res.data.items
      })
    },
    setVal (id, txt) {
      this.items = [
        {
          'id': id,
          'title': txt
        }]
      this.customer = id
    },
    getVal () {
      return this.customer
    }
  },
  mounted () {
    this.qrySelections('')
  }
}
</script>
